import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import generateMeta from "../../../shared/services/metadataService";
import metaData from "../../../config/metaData";
import WelcomeSection from "./sections/welcomeSection";
import AboutSection from "./sections/aboutSection";
import GallerySection from "./sections/gallerySection";
import FeaturedLands from "./sections/featuredLands";
import VideoSection from "./sections/videoSection";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

/**
 * Home component displays a simple "Home works" message.
 * @returns {JSX.Element} The Home component JSX
 */
const Home: React.FC = (): JSX.Element => {
  useEffect(() => {
    // Cleanup ScrollTrigger instances on unmount
    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <div data-testid="home-container" className="w-full h-full">
      {generateMeta({
        title: metaData.home.title,
        description: metaData.home.description,
        keywords: metaData.home.keywords?.split(", "),
        slug: "",
      })}
      <WelcomeSection />
      <AboutSection />
      <GallerySection />
      <VideoSection />
      <FeaturedLands />
    </div>
  );
};

export default Home;
